module.exports = __webpack_public_path__ + "img/stop_btn.f0137afa.png";